module.exports = __webpack_public_path__ + "static/media/D-DIN.eb09665e.ttf";